const normalizeTabName = name => {
  if (typeof name !== 'string') {
    return name
  }

  const normalizedName = name
    .split(',')
    .map(part => part.trim())
    .filter(part => part && part.toLowerCase() !== 'undefined')
    .join(', ')

  return normalizedName || null
}

export default normalizeTabName
